(() => {
  'use strict';
  if (window.fbpEUMenuReady) return;
    window.fbpEUMenuReady = true;
  const initialize = (root = document) => {
    root.querySelectorAll('.header1 .main-menu > li > a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      const target = new URL(href, location.href);
      if (target.origin === location.origin && target.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) link.setAttribute('aria-current', 'page');
    });
    root.querySelectorAll('.fbp-help').forEach(details => {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      details.addEventListener('pointerenter', e => { if(e.pointerType === 'mouse') details.open = true; });
      // Mouse entry already opens the panel; its subsequent click must not close it.
      details.querySelector('summary').addEventListener('click', e => {
        if (e.pointerType === 'mouse') { e.preventDefault(); details.open = true; }
      });
      details.addEventListener('pointerleave', () => { if(!details.contains(document.activeElement)) details.open = false; });
      details.addEventListener('focusout', e => { if(!details.contains(e.relatedTarget)) details.open = false; });
    });
  };
  document.addEventListener('click', e => document.querySelectorAll('.fbp-help[open]').forEach(d => {if(!d.contains(e.target))d.open=false}));
  document.addEventListener('keydown', e => {
    if(e.key !== 'Escape')return;
    document.querySelectorAll('.fbp-help[open]').forEach(d => {d.open=false;d.querySelector('summary').focus()});
  });
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  initialize();
})();
